import { Badge } from "./Badge"
import { Tooltip } from "./Tooltip"

interface NpiForecastValueProps {
  value: React.ReactNode
  npiCount: number
  totalCount: number
  isVariantLevel: boolean
}

export const NpiForecastValue = ({
  value,
  npiCount,
  totalCount,
  isVariantLevel,
}: NpiForecastValueProps) => {
  const hasNpi = npiCount > 0
  const showCount = isVariantLevel && npiCount !== totalCount

  if (!hasNpi) {
    return <>{value}</>
  }

  return (
    <div className="flex items-center justify-between">
      {value}
      <div className="flex items-center">
        <Tooltip
          body={
            <div className="flex flex-col gap-2">
              <div className="font-semibold">
                The forecast {isVariantLevel ? `for ${npiCount} of ${totalCount} variants` : ""} is
                a NPI forecast
              </div>
              <div>
                NPI forecasts are created with limited sales history. They rely more on product
                characteristics, so the forecast can be more uncertain.
              </div>
            </div>
          }
        >
          <Badge variant="tag" size="sm" className="cursor-default mr-1">
            NPI
          </Badge>
        </Tooltip>
        {showCount && <>x{npiCount}</>}
      </div>
    </div>
  )
}
